exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating-box {\n  list-style: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0px;\n}\n.rating-box li img {\n  width: 22px;\n  margin-right: 2px;\n}", ""]);

// exports
